import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ui: {
    loading: false,
    loadingPartner: false,
    loadingProducts: false,
    location: false,
    stats: {
      pageCount: 1,
    },
  },
  sellers: [],
  data: [],
  delivery: [],
  partner: null,
  categories: [],
};

export const sellersReducer = createSlice({
  name: 'sellers',
  initialState,
  reducers: {
    get_sellers_success: (state, { payload }) => {
      state.ui.loading = false;
      state.sellers = payload;
    },
    get_sellers_error: (state) => {
      state.ui.loading = false;
    },
    get_sellers: (state) => {
      state.ui.loading = true;
    },
    get_products_success: (state, { payload }) => {
      state.ui.loadingProducts = false;
      const { products, stats } = payload;
      state.data = products;
      state.ui.stats = {
        ...stats,
      };
    },
    get_sellers_locations: (state) => {
      state.ui.location = true;
    },
    get_sellers_locations_error: (state) => {
      state.ui.location = false;
    },

    get_sellers_locations_success: (state, { payload }) => {
      state.ui.location = false;
      const { locations } = payload;
      state.delivery = locations;
    },

    get_products: (state) => {
      state.ui.loadingProducts = true;
    },

    get_products_error: (state) => {
      state.ui.loadingProducts = false;
    },
    get_partner_id: (state) => {
      state.ui.loadingPartner = true;
    },
    get_partner_id_success: (state, { payload }) => {
      state.ui.loadingPartner = false;
      const { partners } = payload;
      const item = partners[0];
      state.partner = item?._id;
    },
    get_partner_id_error: (state) => {
      state.ui.loadingPartner = false;
    },
    get_categories: (state) => {
      state.ui.loading = true;
    },
    get_categories_success: (state, { payload }) => {
      state.ui.loading = false;
      state.categories = payload.categories;
    },
    get_categories_error: (state) => {
      state.ui.loading = false;
    },
  },
});

// Action creators are generated for each case reducer function

export const {
  get_sellers_success,
  get_sellers_error,
  get_sellers,
  get_products_success,
  get_products_error,
  get_products,
  get_sellers_locations,
  get_sellers_locations_error,
  get_sellers_locations_success,
  get_partner_id,
  get_partner_id_success,
  get_partner_id_error,
  get_categories,
  get_categories_success,
  get_categories_error,
} = sellersReducer.actions;

export default sellersReducer.reducer;
